// /auth/forgot-password-mail
// verify-forgot-otp
import { axiosPrivate } from "src/utils/axios";
import axios from "axios";
import { hostname } from "src/HostName";
import { errorHandlerAxios } from "src/utils/utils.js"
// import  { captureException } from "@sentry/react";

export const forgoPasswordMail = async (body) => {
  try {
    const data = await axiosPrivate.post("auth/forgot-password-mail",body);
    return data;
  } catch (error) {
    return { data : { data : { status : false , message : error.message}} };
  }
};


/**
 {
        "email" : "testeTest2@test.com",
        "otp" : "7718"
}
 */
export const verifyForgotPasswordOtp = async (body) => {
  try {
    const data = await axiosPrivate.post("auth/verify-forgot-otp",body);
    return data.data;
  } catch (error) {
    return { data : { data : { status : false , message : error.message}} };
  }
};

/**
    {
      username: email,
      password: password,
    }
 */
export const loginNetworkCall = async (body) => {
  try {
    axios.defaults.headers.common['key'] = '1f67cc92078c59d28345211501c21b3e98b23de4aabe94ccfe872fc6d8a7d5253530e7';
    const data = await axios.post(`${hostname}agent/login`,body);
    return data.data;
  } catch (error) {
    //  captureException(error);
    return  error.response.data;
  }
};

/**
 * Sends OTP to email via /agent/login-email
 * body: { email: string }
 */
export const loginWithOtpEmail = async (body) => {
  try {
    const data = await axios.post(`${hostname}agent/login-email`, body, {
      headers: {
        key: '1f67cc92078c59d28345211501c21b3e98b23de4aabe94ccfe872fc6d8a7d5253530e7',
      },
    });
    return data.data;
  } catch (error) {
    // captureException(error);
    return error.response?.data ?? { status: false, message: error.message };
  }
};

export const loginOtpVerify = async (body) => { 
  axios.defaults.headers.common['key'] = '1f67cc92078c59d28345211501c21b3e98b23de4aabe94ccfe872fc6d8a7d5253530e7';
  try {
    const data = await axios.post(`${hostname}otp/verification`, body);
    return data.data;
  } catch (error) {
    //  captureException(error);
    return errorHandlerAxios(error);
  }
};

export const logoutUser = async (deviceId,navigationType) => { 
  try {
    const data = await axiosPrivate.post(`logOut/${deviceId}`);
    return data.data;
  } catch (error) {
    return  error.response.data;
  }
};

export const logoutAllDevices = async (userDetail) => { 
  try {
    const data = await axios.post(`${hostname}logout-all-devices`,{...userDetail}, {
        headers: {
          "x-access-token" : userDetail?.token
        }
      });
    return data.data;
  } catch (error) {
    return  error.response.data;
  }
};

export const getUserIpAndCountryCode = async (deviceId,navigationType) => { 
  try {
    const data = await axios.get(`https://ipf.travomint.com/search/getUserIpAndCountryCode?authCodes=Trust370498H9181`);
    return data.data;
  } catch (error) {
    return  error.response.data;
  }
};


export const editUserPassword = async (body) => { 
  try {
    const data = await axiosPrivate.post("auth/edit-user-password",body);
    return data.data;
  } catch (error) {
    return  error.response.data;
  }
};

